<template>
  <div class="banners-wrapper">
    <div class="flight-banner">
      <div class="carousel-container">
        <div
          class="carousel-track"
          :style="{ transform: `translateX(-${currentImageIndex * 100}%)` }"
        >
          <img
            v-for="(item, index) in images"
            :key="index"
            :src="item.src"
            alt="Ofertas de Vuelos"
            class="banner-image"
            @click="redirectToWhatsApp(item.message)"
          />
        </div>
      </div>
    </div>
    <!--<a
      href="/documents/Politica_de_privacidad_y_tratamiento_de_datos_personales_AviaMarketing_SAS.pdf"
      target="_blank"
      class="policy-banner"
    >
      <img
        src="@/assets/images/politica_1200.svg"
        alt="Política de tratamiento de datos personales"
        class="banner-image"
      />
    </a>-->
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";

const isMobile = ref(false);

const bannerItems = [
  {
    desktop: require("@/assets/images/Plan-Europa-Infinita-1200.webp"),
    mobile: require("@/assets/images/Plan-Europa-Infinita-600.webp"),
    message:
      "¡Hola! Quiero saber más del plan Europa infinita en Antojese.travel",
  },
  {
    desktop: require("@/assets/images/BsearchFlight-1200.svg"),
    mobile: require("@/assets/images/BsearchFlight-600.svg"),
    message:
      "¡Hola! Quiero saber más de los vuelos en Antojese.travel",
  }
];

const images = computed(() => {
  return bannerItems.map((item) => ({
    src: isMobile.value ? item.mobile : item.desktop,
    message: item.message,
  }));
});

const currentImageIndex = ref(0);
let carouselInterval;

const phoneNumber = process.env.VUE_APP_WHATSAPP_SALES_NUMBER1;

const redirectToWhatsApp = (message) => {
  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  window.open(url, "_blank");
};

const handleResize = () => {
  isMobile.value = window.innerWidth <= 600;
};

onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
  carouselInterval = setInterval(() => {
    currentImageIndex.value =
      (currentImageIndex.value + 1) % images.value.length;
  }, 5000); // Cambia la imagen cada 5 segundos
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  clearInterval(carouselInterval);
});
</script>

<style scoped>
.banners-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.flight-banner {
  cursor: pointer;
}
.carousel-container {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
}
.carousel-track {
  display: flex;
  width: 100%;
  transition: transform 0.5s ease-in-out;
}
.banner-image {
  width: 100%;
  flex-shrink: 0;
  display: block;
  border-radius: 10px;
}
</style>
